import React, { useEffect, useState, useCallback } from "react";
import { Container, TextField, MenuItem } from "@material-ui/core";
import { useBmapi } from "../../utils/bmapi-context";
import { getErrorMessageString } from "../../utils/errors";
import { useIntl } from "react-intl";
import ReservationsConfigLegacy from "../../components/ReservationsConfigLegacy";
import ReservationsConfigDynamic from "../../components/ReservationsConfigDynamic";

const byName = (a, b) => a.name.localeCompare(b.name);

// helper già presente nel legacy
function getEventDays(start_date, expiration_date) {
  const startDate = new Date(start_date);
  const expirationDate = new Date(expiration_date);

  if (startDate > expirationDate) return [];

  const daysArray = [];
  const currentDate = new Date(startDate);

  while (currentDate <= expirationDate) {
    daysArray.push(formatLocalDate(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return daysArray;
}

function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function ReservationsConfig(props) {
  const intl = useIntl();
  const { bmapi, notifyError, startLoading, stopLoading } = useBmapi();

  const [fairList, setFairList] = useState([]);
  const [fairFilter, setFairFilter] = useState(undefined);
  const [reservationMode, setReservationMode] = useState("reg");

  const [isDirty, setIsDirty] = useState(false); // ✅ NUOVO

  const isEventCampaign =
    bmapi.settings?.reservation?.type === "event-campaign";

  const isProfMode = isEventCampaign && reservationMode === "prof";

  const confirmLeave = () => {
    if (!isDirty) return true;

    return window.confirm("Hai modifiche non salvate. Vuoi davvero procedere?");
  };

  const loadFairs = useCallback(() => {
    startLoading();

    if (bmapi) {
      if (isEventCampaign) {
        bmapi
          .getBusinessCampaigns({})
          .then((resp) => {
            if (!resp) resp = [];
            else {
              resp = resp
                .filter((obj) => !obj.campaign_data?.rules?.main_event_id)
                .sort(byName)
                .map((c) => ({
                  name: c?.campaign_data?.name,
                  id: c?.campaign_data?.id,
                  dates: getEventDays(c.start_date, c.expiration_date),
                }));
            }

            setFairList(resp);
            setFairFilter(resp[0]);
          })
          .catch((e) => {
            notifyError(getErrorMessageString(e, intl));
          })
          .finally(() => {
            stopLoading();
          });
      } else {
        bmapi
          .getFairsDates({ type: "FAIR" })
          .then((resp) => {
            if (!resp) resp = [];
            else resp.sort(byName);

            setFairList(resp);
            setFairFilter(resp[0]);
          })
          .catch((e) => {
            notifyError(getErrorMessageString(e, intl));
          })
          .finally(() => {
            stopLoading();
          });
      }
    }
  }, [bmapi, isEventCampaign, intl, notifyError, startLoading, stopLoading]);

  useEffect(() => {
    loadFairs();
  }, [loadFairs]);

  return (
    <Container maxWidth={isProfMode ? "lg" : "sm"}>
      {/* TENDINA FIERA / CAMPAIGN */}
      {fairList.length > 0 && fairFilter && (
        <TextField
          margin="normal"
          select
          fullWidth
          label="Fiera"
          value={fairFilter}
          onChange={(e) => {
            if (!confirmLeave()) return;

            setFairFilter(e.target.value);
            setIsDirty(false); // reset
          }}
        >
          {fairList.map((option) => (
            <MenuItem key={option.id} value={option}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      )}

      {/* TENDINA TIPO */}
      {isEventCampaign && (
        <TextField
          margin="normal"
          select
          fullWidth
          label="Tipo"
          value={reservationMode}
          onChange={(e) => {
            if (!confirmLeave()) return;

            setReservationMode(e.target.value);
            setIsDirty(false); // reset
          }}
        >
          <MenuItem value="reg">Iscrizione</MenuItem>
          <MenuItem value="prof">Colloqui</MenuItem>
        </TextField>
      )}

      {/* SWITCH COMPONENTE */}
      {isProfMode ? (
        <ReservationsConfigDynamic
          {...props}
          fair={fairFilter}
          onDirtyChange={setIsDirty} // ✅ COLLEGAMENTO
        />
      ) : (
        <ReservationsConfigLegacy {...props} fairFromWrapper={fairFilter} />
      )}
    </Container>
  );
}
